import React from 'react';
import './DriverSelectModal.css';

const DEFAULT_PROFILE = '/images/default_admin_pic.jpeg';

const formatDriverPhone = (driver) => {
  if (!driver?.phoneNumber) return '';
  const code = driver.countryCode || '';
  return code ? `${code} ${driver.phoneNumber}` : driver.phoneNumber;
};

const DriverSelectModal = ({
  isOpen,
  onClose,
  drivers = [],
  selectedDriverId = '',
  onSelect,
  loading = false,
  title = 'Select Driver',
  mode = 'select',
  onShareOther,
}) => {
  if (!isOpen) return null;

  const isShareMode = mode === 'share';
  const visibleDrivers = isShareMode ? drivers : drivers.filter((d) => d.status !== false);
  const selectedId = selectedDriverId ? String(selectedDriverId) : '';

  return (
    <div className="driver-select-overlay" onClick={onClose}>
      <div className="driver-select-modal" onClick={(e) => e.stopPropagation()}>
        <div className="driver-select-header">
          <h3>{title}</h3>
          <button type="button" className="driver-select-close" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>
        <div className="driver-select-body">
          {visibleDrivers.length === 0 && !isShareMode ? (
            <p className="driver-select-empty">No active drivers found.</p>
          ) : (
            <div className="driver-select-grid">
              {visibleDrivers.map((driver) => {
                const driverId = String(driver._id);
                const isSelected = !isShareMode && selectedId === driverId;
                return (
                  <button
                    key={driverId}
                    type="button"
                    className={`driver-select-item ${isSelected ? 'active' : ''}`}
                    disabled={loading}
                    onClick={() => onSelect(driver)}
                  >
                    <div
                      className="driver-select-avatar"
                      style={{ borderColor: driver.color || '#3b82f6' }}
                    >
                      <img
                        src={driver.profilePicture || DEFAULT_PROFILE}
                        alt={driver.name}
                        className="driver-select-avatar-img"
                        onError={(e) => { e.target.src = DEFAULT_PROFILE; }}
                      />
                    </div>
                    <div className="driver-select-info">
                      <span className="driver-select-name">{driver.name}</span>
                      {formatDriverPhone(driver) && (
                        <span className="driver-select-phone">{formatDriverPhone(driver)}</span>
                      )}
                    </div>
                  </button>
                );
              })}
              {isShareMode && (
                <button
                  type="button"
                  className="driver-select-item driver-select-item-other"
                  onClick={onShareOther}
                >
                  <div className="driver-select-info">
                    <span className="driver-select-name">Other</span>
                  </div>
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DriverSelectModal;
